import {
  capitalize,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import FacetFilter from "models/facet-filter";
import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const Filter = ({
  facetListLength,
  index,
  filter,
  facetType,
  OnUpdated,
}: {
  facetListLength: number;
  index: number;
  filter: FacetFilter;
  facetType: string;
  OnUpdated: (filterType: string, filter: string) => void;
}) => {
  const theme = useEasierTheme();
  const [searchParams] = useSearchParams();
  const selectedFilter = useMemo(
    () => searchParams.get(facetType) === filter.field,
    [filter, facetType],
  );
  return (
    <ListItem
      disablePadding
      sx={{
        border: "solid",
        borderWidth: 1,
        borderBottomLeftRadius:
          facetListLength - 1 === index ? "4px" : undefined,
        borderBottomRightRadius:
          facetListLength - 1 === index ? "4px" : undefined,
        ...(["FAF-nt", "nrdata-orig"].includes(
          process.env.REACT_APP_STYLING_THEME ?? "",
        )
          ? {
              borderColor: "rgba(0, 0, 0, 0.125)",
              background: "#ffffff",
            }
          : {
              borderColor: theme?.Colour.SecondaryContainer(),
            }),
      }}
    >
      <ListItemButton
        sx={{
          ...(["FAF-nt", "nrdata-orig"].includes(
            process.env.REACT_APP_STYLING_THEME ?? "",
          )
            ? facetListLength - 1 === index
              ? {
                  borderBottomLeftRadius: "4px",
                  borderBottomRightRadius: "4px",
                }
              : undefined
            : {
                background: selectedFilter ? "#d6d6d6" : "#ffffff",
              }),
        }}
        onClick={() => {
          OnUpdated(facetType, filter.field);
        }}
        selected={selectedFilter}
      >
        <ListItemText
          primary={
            <Typography
              sx={{
                wordBreak: "break-word",
                whiteSpace: "normal",
                overflowWrap: "break-word",
              }}
            >
              {capitalize(filter.field)}
            </Typography>
          }
          sx={{ pr: 2 }}
        />
        <Typography
          sx={{
            color: theme?.Colour.InverseOnSurface(),
            p: "4px",
            borderRadius: "14px",
            minWidth: "24px",
            textAlign: "center",
            lineHeight: 1,
            wordWrap: "break-word",
            ...(["FAF-nt", "nrdata-orig"].includes(
              process.env.REACT_APP_STYLING_THEME ?? "",
            )
              ? {
                  fontSize: "13px",
                  fontWeight: 600,
                  backgroundColor: "#1F1F5F",
                }
              : {
                  backgroundColor: "#50505a",
                }),
          }}
          variant="caption"
        >{`${filter.count}`}</Typography>
      </ListItemButton>
    </ListItem>
  );
};

export default Filter;
